import { IControl } from 'mapbox-gl';

/**
 *  CustomComponentControl allows adding new component controls to map.
 * 
 * @param {any} customComponent Node that will be appended as child to div container.
 * 
 * @example
 * const environmentInjector = this.appRef.injector;
    const myCustomComponent = createComponent(MyCustomComponent, {
      environmentInjector,
    });
    this.appRef.attachView(myCustomComponent.hostView);
    myCustomComponent.setInput('property1', value1);
    myCustomComponent.setInput('property2', value2);
 */
export class CustomComponentControl implements IControl {
  _map!: mapboxgl.Map | undefined;
  _container!: HTMLDivElement;

  constructor(private customComponent: any) {}

  onAdd(map: mapboxgl.Map) {
    this._map = map;
    this._container = document.createElement('div');
    this._container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';
    this._container.appendChild(this.customComponent);
    return this._container;
  }

  onRemove() {
    this._container.parentNode!.removeChild(this._container);
    this._map = undefined;
  }
}
